import { render } from "./companyInformation.vue?vue&type=template&id=d2379f40"
import script from "./companyInformation.vue?vue&type=script&lang=js"
export * from "./companyInformation.vue?vue&type=script&lang=js"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__